module.exports = __webpack_public_path__ + "2296674332331a33c9e421adb846f844.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/british-american-tobacco-plc.png
// module id = 1766
// module chunks = 0